import axios from 'axios';
import { checkToken, logoutAuthNotification } from './auth';

export const get = (url, pathParam, isSkipLoader = false) => {
    return new Promise((resolve, reject) => {
        if (checkToken()) {
            logoutAuthNotification()
            //return reject("Token Expire");

        } else {
            axios
                .get(url + pathParam, { skipLoader: isSkipLoader }).then((response) => {

                    return resolve(response);
                })
                .catch((error) => {
                    return reject(error)
                });
        }
    });
}

export const post = (url, pathParam, data, isSkipLoader = false) => {
    return new Promise((resolve, reject) => {
        if (checkToken()) {
            logoutAuthNotification()
            //return reject("Token Expire");

        } else {
            axios
                .post(url + pathParam, data, { skipLoader: isSkipLoader })
                .then((response) => {

                    return resolve(response);
                })
                .catch((error) => {
                    return reject(error)
                });
        }
    });
}

export const put = (url, pathParam, data, isSkipLoader = false) => {
    return new Promise((resolve, reject) => {
        if (checkToken()) {
            logoutAuthNotification()
            //return reject("Token Expire");

        } else {
            axios
                .put(url + pathParam, data, { skipLoader: isSkipLoader }).then((response) => {

                    return resolve(response);
                })
                .catch((error) => {
                    return reject(error)
                });
        }
    });
}

export const destory = (url, pathParam, isSkipLoader = false) => {
    return new Promise((resolve, reject) => {
        if (checkToken()) {
            logoutAuthNotification()
            //return reject("Token Expire");

        } else {
            axios
                .delete(url + pathParam, { skipLoader: isSkipLoader }).then((response) => {

                    return resolve(response);
                })
                .catch((error) => {
                    return reject(error)
                });
        }
    });
}

export const options = (url, pathParam, isSkipLoader = false) => {
    return new Promise((resolve, reject) => {
        if (checkToken()) {
            logoutAuthNotification()
            //return reject("Token Expire");

        } else {
            axios
                .options(url + pathParam, { skipLoader: isSkipLoader }).then((response) => {

                    return resolve(response);
                })
                .catch((error) => {
                    return reject(error)
                });
        }
    });
}

export const fileUpload = (url, obj) => {
    let options = {
        headers: {
            'Content-Type': "multipart/form-data"
        }
    };
    return new Promise((resolve, reject) => {
        if (checkToken()) {
            logoutAuthNotification()
            //return reject("Token Expire");

        } else {
            axios
                .put(url, obj, options).then((response) => {

                    return resolve(response);
                })
                .catch((error) => {
                    return reject(error)
                });
        }
    });
}

export const fileUploadPost = (url, obj) => {
    let options = {
        headers: {
            'Content-Type': "multipart/form-data"
        }
    };
    return new Promise((resolve, reject) => {
        if (checkToken()) {
            logoutAuthNotification()
            //return reject("Token Expire");

        } else {
            axios
                .post(url, obj, options).then((response) => {

                    return resolve(response);
                })
                .catch((error) => {
                    return reject(error)
                });
        }
    });
}

export const fileUploadPostToken = (url, obj, token) => {
    let options = {
        handlerEnabled: false,
        headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": `Bearer ${token}`
        },
    };
    return new Promise((resolve, reject) => {
        if (checkToken()) {
            logoutAuthNotification();
            //return reject("Token Expire");
        } else {
            axios
                .post(url, obj, options)
                .then((response) => {
                    return resolve(response);
                })
                .catch((error) => {
                    return reject(error);
                });
        }
    });
};

export const getFileBlob = (url, pathParam) => {
    return new Promise((resolve, reject) => {
        if (checkToken()) {
            logoutAuthNotification()
            //return reject("Token Expire");

        } else {
            axios
                .get(url + pathParam, { responseType: 'blob' }).then((response) => {

                    return resolve(response);
                })
                .catch((error) => {
                    return reject(error)
                });

        }
    });
}

export const postCustomToken = (url, pathParam, token, obj) => {

    return new Promise((resolve, reject) => {
        if (checkToken()) {
            logoutAuthNotification();
        }
        else {
            axios.post(url + pathParam, obj, {
                handlerEnabled: false,
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then((response) => {
                return resolve(response)
            })
                .catch((error) => {
                    return reject(error)
                });
        }
    });
}

export const getCustomToken = (url, pathParam, token, isSkipLoader = false) => {
    return new Promise((resolve, reject) => {
        if (checkToken()) {
            logoutAuthNotification();
        } else {
            axios
                .get(url + pathParam, {
                    skipLoader: isSkipLoader,
                    handlerEnabled: false,
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                .then((response) => {
                    return resolve(response);
                })
                .catch((error) => {
                    return reject(error);
                });
        }
    });
};

export const putCustomToken = (url, pathParam, token, obj) => {

    return new Promise((resolve, reject) => {
        if (checkToken()) {
            logoutAuthNotification();
        }
        else {
            axios.put(url + pathParam, obj, {
                handlerEnabled: false,
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then((response) => {
                return resolve(response)
            })
                .catch((error) => {
                    return reject(error)
                });
        }
    });
}

export const postForm = (url, pathParam, obj, isSkipLoader = false) => {
    return new Promise((resolve, reject) => {
        if (checkToken()) {
            logoutAuthNotification()
            //return reject("Token Expire");

        } else {
            const encodedPayload = Object.keys(obj).map(key => key + '=' + obj[key]).join('&');
            axios
                .post(url + pathParam, encodedPayload, {
                    skipLoader: isSkipLoader, headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
                    }
                })
                .then((response) => {

                    return resolve(response);
                })
                .catch((error) => {
                    return reject(error)
                });
        }
    });
}

export const uploadFile = (url, pathParam, obj, isSkipLoader = false) => {
    return new Promise((resolve, reject) => {
        if (checkToken()) {
            logoutAuthNotification()
            //return reject("Token Expire");

        } else {
            const encodedPayload = Object.keys(obj).map(key => key + '=' + obj[key]).join('&');
            axios
                .post(url + pathParam, encodedPayload, {
                    skipLoader: isSkipLoader, headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
                    }
                })
                .then((response) => {

                    return resolve(response);
                })
                .catch((error) => {
                    return reject(error)
                });
        }
    });
}

export const file = (url, pathParam, file, onUploadProgress, isSkipLoader = false) => {
    return new Promise((resolve, reject) => {
        if (checkToken()) {
            logoutAuthNotification()
            //return reject("Token Expire");

        } else {
            axios
                .post(url + pathParam, file, {
                    skipLoader: isSkipLoader,
                    onUploadProgress: progress => { onUploadProgress(progress) }
                }).then((response) => {
                    return resolve(response);
                })
                .catch((error) => {
                    return reject(error)
                });
        }
    });
}

export const postRequestWithCustomHeader = (url, pathParam, data, headers, isSkipLoader = false) => {
    return new Promise((resolve, reject) => {
        if (checkToken()) {
            logoutAuthNotification()
            //return reject("Token Expire");

        } else {
            axios
                .post(url + pathParam, data, { skipLoader: isSkipLoader, headers: headers })
                .then((response) => {

                    return resolve(response);
                })
                .catch((error) => {
                    return reject(error)
                });
        }
    });
}

export const destoryCustomToken = (url, pathParam, token, isSkipLoader = false) => {
    return new Promise((resolve, reject) => {
        if (checkToken()) {
            logoutAuthNotification()
            //return reject("Token Expire");

        } else {
            axios
                .delete(url + pathParam, {
                    skipLoader: isSkipLoader,
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }).then((response) => {

                    return resolve(response);
                })
                .catch((error) => {
                    return reject(error)
                });
        }
    });
}
